import { useState } from "react";
import { Link, Navigate, useParams } from "react-router-dom";
import { AppLayout } from "../../components/layout/Header";
import ConfirmClientModal from "../../components/client/ConfirmClientModal";
import { getClientByCode } from "../../js/api/clientAccess";
import { useAuth } from "../../js/hooks/useAuth";
import { useDesk } from "../../js/hooks/useDesk";
import { buyerFileId, sellerFileId } from "../../js/api/filePacket/ids";

export default function DeskClientLookup() {
  const { clientCode } = useParams();
  const desk = useDesk();
  const { session } = useAuth();
  const client = getClientByCode(clientCode);
  const [open, setOpen] = useState(true);
  const variant = session?.role === "broker" ? "broker" : "agent";

  if (!clientCode) {
    return <Navigate to={desk.clients} replace />;
  }

  const profileTo =
    client?.role_type === "seller"
      ? desk.file(sellerFileId(client.id))
      : client
        ? desk.client(client.id)
        : desk.clients;

  if (!client) {
    return (
      <AppLayout variant={variant}>
        <article className="card">
          <h1>Client not found</h1>
          <p>That Client ID is not on this desk.</p>
          <Link to={desk.clients}>Client Manager</Link>
        </article>
      </AppLayout>
    );
  }

  if (!open) {
    return <Navigate to={desk.clients} replace />;
  }

  return (
    <AppLayout variant={variant}>
      <article className="card">
        <p className="muted">Confirm this client before opening their file.</p>
      </article>
      <ConfirmClientModal client={client} profileTo={profileTo} isOpen={open} onClose={() => setOpen(false)} />
    </AppLayout>
  );
}
